export default function validation(response, messages, idsError, listeConstatationCharge) {
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message !== null) {
      if (message.indexOf('PAYER_OF_ORDER_HAS_NO_PAYMENT_TYPE') === 0) {
        const splitMessage = message.split('|')[0].split('@');
        const ligneConstatationCharge = listeConstatationCharge.find((ligne) => {
          return ligne.id === splitMessage[1];
        });
        idsError.push(ligneConstatationCharge.id);
        if (ligneConstatationCharge) {
          messages.push({
            message: 'listeConstatationCharge.messages.error.noPaymentType',
            parametres: {
              code: ligneConstatationCharge.codeDossier,
            },
          });
        } else {
          messages.push({ message: 'listeConstatationCharge.messages.error.noPaymentTypeNoCode' });
        }
      }
    }
  });
}
